import { render, staticRenderFns } from "./saveApproval.vue?vue&type=template&id=88e67942&"
import script from "./saveApproval.vue?vue&type=script&lang=js&"
export * from "./saveApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports